import { Injectable } from '@angular/core';
import { ProjectModel } from '../../../core/services/project.model.service';
import * as _ from 'lodash';

export const permLevelSiteAdmin = 1;
export const permLevelProjectAdmin = 99;

export const permLevelAdmin = 2;
export const permLevelRead = 1;
export const permLevelNoAccess = 0;

@Injectable()
export class PackageModelService {

    constructor(private projectModel: ProjectModel) { }

    public errorTemplate = { packageName: '' };

    public visibilityOptions = {
        fieldName: false,
        fieldElements: [
            { id: 'everyone', label: 'Everyone', defaultSelected: true },
            { id: 'loggedusers', label: 'Logged Users', defaultSelected: false },
            { id: 'projectmembers', label: 'Project Members', defaultSelected: false },
            { id: 'projectadmins', label: 'Project Admins', defaultSelected: false }
        ]
    };

    // An abbreviated version of visibilityOptions, above.
    public visibilityChoices = {
        'Everyone': 'everyone',
        'Users': 'loggedusers',
        'Members': 'projectmembers',
        'Admins': 'projectadmins'
    };

    public permissionsMatrix = {
        everyone: { isVisible: 'Y', isPublic: 'Y', requireLogin: 'N' },
        loggedusers: { isVisible: 'Y', isPublic: 'Y', requireLogin: 'Y' },
        projectmembers: { isVisible: 'Y', isPublic: 'N', requireLogin: 'Y' },
        projectadmins: { isVisible: 'N', isPublic: 'N', requireLogin: 'Y' }
    };

    public errorTypes = {
        uniquePackageName: 'Package name already exists.',
        length: 'Package name length must be 4 characters min. and 30 characters max.'
    };

    public acl: any = {};

    public data: any = {};

    public errors: any = {};

    public resetErrors() {
        this.errors = _.cloneDeep(this.errorTemplate);
    }

    public getFrsPermissions(permissions) {
        return _.reduce(
            permissions,
            (carry, item: any) => {
                if (item.section == 'frspackage') {
                    carry[item.refId] = item.value;
                }
                return carry;
            },
            {}
        );
    }

    public getReleaseAdminStatus(permissions) {
        return _.reduce(
            permissions,
            (carry, item: any) => {
                if (item.section == 'frs' && item.value == permLevelSiteAdmin) {
                    carry = true;
                }
                return carry;
            },
            false
        );        
    }

    public getProjectAdminStatus(permissions) {
        return _.reduce(
            permissions,
            (carry, item: any) => {
                if (item.section == 'projectadmin' && item.value == permLevelProjectAdmin) {
                    carry = true;
                }
                return carry;
            },
            false
        );
    }

    public getSiteAdminStatus(permissions) {
        return permissions.length == 1 && 
            permissions[0].section == 'siteadmin' && 
            permissions[0].value == 100;
    }

    public setAcl(userUnixName, projectUnixName) {
        return new Promise(
            async (resolve, reject) => {
                this.acl = await this.getAcl(userUnixName, projectUnixName);
                resolve(this.acl);
        });        
    }

    public async getAcl(userUnixName, projectUnixName) {
        const data = await this.projectModel.getPermissions(userUnixName, projectUnixName);

        return {
            permissions: this.getFrsPermissions(data),
            projectwideReleasesAdminStatus: this.getReleaseAdminStatus(data),
            siteAdminStatus: this.getSiteAdminStatus(data),
            projectAdminStatus: this.getProjectAdminStatus(data),
            getPermissionLevelForPackage: function (_package) {
                return this.permissions[_package?.id];
            },
            canSubmit: function () {
                return this.siteAdminStatus
                    || this.projectAdminStatus
                    || this.projectwideReleasesAdminStatus;
            },
            isAdmin: function (_package) {
                return this.canSubmit()
                    || (this.getPermissionLevelForPackage(_package) == permLevelAdmin);
            }
        };
    }
}